import * as yup from "yup";

export const exportDataFormSchema = yup.object().shape({
  headers: yup.array(yup.string()).default([]),
  exportFormat: yup.string().required("Required").oneOf(["csv", "xlsx"]),
});
